import * as utils from "../../components/utils";

const PackageInit = {
    init() {
        utils.consoleLog('PackageInit.js', 'Hello World');
    }
};

export default PackageInit;
